import React from 'react';
import { useParams } from 'react-router-dom';
import ClientContractsForm from 'components/Forms/ClientContractsForm';

const ClientBuyerContractsCreatePage: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();

  return <ClientContractsForm client={clientId} />;
};
export default ClientBuyerContractsCreatePage;
